import { ReactNode } from 'react';

import { SelectInput } from 'components/SelectInput';
import { updateObject } from 'utils/functional';

import { Field } from './Field/Field';

type Props = {
  'aria-label'?: string;
  'data-qa-id'?: string;
  className?: string;
  customCompare?: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg0: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg1: Record<string, any>,
  ) => boolean;
  disabled?: boolean;
  disableGreyOnNull?: boolean;
  name: string;
  value?: string;
  label?: ReactNode;
  description?: string;
  options: ReadonlyArray<{
    value: string | number | null | undefined;
    label: string;
    disabled?: boolean;
  }>;
  onUpdateValue?: (arg0: string) => void;
  noMargin?: boolean;
  noWrap?: boolean;
  hasError?: boolean;
  id?: string;
  onChange?: (arg0: string) => void;
  required?: boolean;
};

export function SelectField({
  name,
  label,
  description,
  options,
  noMargin,
  noWrap,
  onUpdateValue,
  required,
  ...props
}: Props) {
  return (
    <Field
      inputProps={updateObject(props, {
        options,
      })}
      name={name}
      label={label}
      description={description}
      noMargin={noMargin}
      noWrap={noWrap}
      renderInput={({ value, id, qaId, hasError, updateValue }) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const update = (v: any) => {
          updateValue(v);

          if (onUpdateValue) {
            onUpdateValue(v);
          }
        };

        return (
          <SelectInput
            id={id}
            name={name}
            value={value || ''}
            options={options}
            hasError={hasError}
            data-qa-id={qaId}
            onChange={update}
            required={required}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        );
      }}
    />
  );
}
